import React from 'react';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import commaNumber from 'comma-number';
import secureLocalStorage from 'react-secure-storage';
import { ToWords } from 'to-words';
import moment from 'moment';

const QuotationPDF = ({ quotationData, markupPrice, tripType, price }) => {
  const toWords = new ToWords();
  const flight = {
    // width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  };
  const twenty = {
    width: '24%',
    // border: '1px solid #222222',
    borderRadius: '5px',
    padding: '5px',
    margin: '2px',
  };
  const title = {
    fontSize: '10px',
    color: '#eb1933',
  };
  const city = {
    fontSize: '14px',
    color: '#eb1933',
  };
  const airport = {
    fontSize: '11px',
    fontWeight: '400',
    color: '#525371',
    padding: '2px 0',
  };
  const date = {
    fontSize: '10px',
    color: '#222222',
  };
  const code = {
    fontSize: '10px',
    color: '#222222',
    paddingTop: '5px',
  };

  const circle = {
    backgroundColor: '#9c9797',
    height: '10px',
    width: '10px',
    borderRadius: '10px',
  };
  const line = {
    position: 'absolute',
    width: '100%',
    borderBottom: '1px solid #9c9797',
    top: '5px',
  };

  const flightFont = {
    fontSize: '10px',
    color: '#222222',
    display: 'block',
    marginBottom: '7px',
  };
  const flightFont1 = {
    fontSize: '8px',
    color: '#222222',
    display: 'block',
    marginBottom: '7px',
  };
  const adress = {
    fontSize: '10px',
    color: '#8b8b8b',
  };

  const users = secureLocalStorage.getItem('user-info');

  const minitConvert = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };
  console.log(users);
  return (
    <Document>
      <Page size="A4" style={{ padding: '27px 20px' }}>
        <View style={{ padding: '15px' }}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '10px',
            }}
          >
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <View
                style={{
                  fontSize: '10px',
                  display: 'flex',
                  width: '800px',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                }}
              >
                <Text
                  style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    paddingBottom: '5px',
                    color: '#222222',
                  }}
                >
                  {users?.company}
                </Text>
                <Text style={adress}>
                  Email: {users?.email},&nbsp;Phone: {users?.phone},&nbsp;
                  Address: {users?.address}
                </Text>
              </View>
            </View>
            {/* <View
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
            >
              <Image
                style={{ height: '50px', border: '1px solid red' }}
                src="https://flyjatt-b2b.sgp1.cdn.digitaloceanspaces.com/airlines/logo/bg.webp"
              />
            </View> */}
          </View>
          <View>
            <View style={flight}>
              <Text
                style={{
                  fontSize: '13px',
                  backgroundColor: 'red',
                  color: 'white',
                  padding: '5px 10px',
                }}
              >
                Flight Details
              </Text>
            </View>
            {quotationData?.AllLegsInfo?.map((data, i, array) => (
              <View>
                <View>
                  {data?.Segments?.map((item, index, arr) => (
                    <View style={flight}>
                      <View style={twenty}>
                        <Text style={title}>{item?.MarketingCarrierName}</Text>
                        <Text style={code}>
                          {item.MarketingCarrier}&nbsp;-&nbsp;
                          {item?.MarketingFlightNumber}
                          {' & '}
                          {item?.SegmentCode?.bookingCode}
                        </Text>
                      </View>
                      <View style={twenty}>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'baseline',
                          }}
                        >
                          <Text style={city}>
                            {item?.DepLocation?.slice(0, -2)}
                          </Text>
                          <Text style={title}>&nbsp;{item?.DepFrom}</Text>
                        </View>

                        <Text style={airport}>{item?.DepAirPort}</Text>
                        <Text style={date}>
                          {moment(item?.DepTime?.split('+')[0])?.format(
                            'DD MMM YYYY h:mmA'
                          )}
                        </Text>
                      </View>
                      <View style={twenty}>
                        <View style={{ position: 'relative' }}>
                          <View
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                            }}
                          >
                            <View style={circle}></View>
                            <View style={circle}></View>
                          </View>
                          <Text
                            style={{
                              fontSize: '10px',
                              textAlign: 'center',
                            }}
                          >
                            {minitConvert(item?.Duration)}
                          </Text>
                          <View style={line}></View>
                        </View>
                      </View>
                      <View style={twenty}>
                        <View style={{ textAlign: 'right' }}>
                          <View
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'baseline',
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Text style={city}>
                              {item?.ArrLocation?.slice(0, -2)}
                            </Text>
                            <Text style={title}>&nbsp;{item?.ArrTo}</Text>
                          </View>

                          <Text style={airport}>{item?.ArrAirPort}</Text>
                          <Text style={date}>
                            {moment(item?.ArrTime?.split('+')[0])?.format(
                              'DD MMM YYYY h:mmA'
                            )}
                          </Text>
                        </View>
                      </View>
                    </View>
                  ))}
                </View>
              </View>
            ))}
          </View>
          <View>
            <Text>
              {quotationData?.Refundable === true ? (
                <Text style={{ color: 'green', fontSize: 12 }}>
                  Refundable Fare
                </Text>
              ) : (
                <Text style={{ color: 'red', fontSize: 12 }}>
                  Non Refundable Fare
                </Text>
              )}
            </Text>
          </View>
          {price && (
            <View>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '70%',
                  fontSize: '10px',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  margin: '20px 0px',
                  border: '1px solid #222222',
                  padding: '10px',
                  borderRadius: '6px',
                }}
              >
                <View>
                  <View>
                    <Text style={{ marginBottom: '5px' }}>Base Fare</Text>
                    <Text style={{ marginBottom: '5px' }}>Tax</Text>
                    <Text style={{ color: '#222222' }}>
                      ---------------------------------------------------------------------------------------
                    </Text>
                    <Text style={{ color: '#222222' }}>
                      Customer Total Ticket Fare{' '}
                    </Text>
                  </View>
                </View>
                <View>
                  <Text style={{ marginBottom: '5px' }}>
                    {commaNumber(
                      Number.parseInt(quotationData?.BaseFare) +
                        Math.ceil(markupPrice / 2)
                    ) || ''}{' '}
                    <span>AED</span>
                  </Text>
                  <Text style={{ marginBottom: '5px' }}>
                    {commaNumber(
                      Number.parseInt(quotationData?.Taxes) +
                        Math.ceil(markupPrice / 2)
                    )}{' '}
                    <span>AED</span>
                  </Text>
                  <Text style={{ color: '#222222' }}>------------------</Text>
                  <Text style={{ color: '#222222' }}>
                    {commaNumber(
                      Number.parseInt(quotationData?.NetFare) +
                        Number.parseInt(markupPrice)
                    )}{' '}
                    <span>AED</span>
                  </Text>
                </View>
              </View>
              <View>
                <Text
                  style={{
                    fontSize: '11px',
                    color: '#222222',
                    padding: '10px 0px',
                  }}
                >
                  In Words:{' '}
                  {toWords.convert(
                    Number.parseInt(quotationData?.NetFare) +
                      Number.parseInt(markupPrice)
                  ) || ''}{' '}
                  Taka Only
                </Text>
              </View>
            </View>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default QuotationPDF;
